import React from "react";
import "./styles.scss";
import { SkeletonImg } from "../../../common/Skeletion";
import SkeletonLine from "../../../common/Skeletion/line";

import Button from "../../../common/button";
import { useNavigate } from "react-router-dom";

const Banner = (props) => {
  const { background_image, button_text, description, title } = props;
  const Navigate = useNavigate();
  const backgroundStyle = {
    background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 70.84%)`,
    zIndex: 2,
  };
  return (
    <>
    <div className="banner-container">
      <div
        className="ratio"
        style={{ height: background_image ? "100%" : "28vh" }}
      ></div>
      {/* <div className="home-banner-container">
        <div className="section">
          <div>
            <h3>{title}</h3>
            <p dangerouslySetInnerHTML={{ __html: description }} />
          </div> */}

          {/* {button_text ? (
            <Button
              onClick={() =>
                Navigate(`${process.env.REACT_APP_BASE}/risk-fall`)
              }
            >
              {button_text}
            </Button>
          ) : (
            <SkeletonLine
              style={{
                height: "3vh",
              }}
            />
          )} */}
        {/* </div>
      </div> */}
      <div className="bgImage" style={backgroundStyle} />
      <div className="bgImage img">
        {background_image ? (
          <img src={background_image} alt="banner" title="banner" />
        ) : (
          <SkeletonImg style={{ height: "40vh", borderRadius: 0 }} />
        )}
      </div>
    </div>
    <div className="home-banner-content">
        <div className="section">
          <div>
            <h3>{title}</h3>
            <p dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
